const componentRequireContext = require.context('../companion', true);
const ReactRailsUJS = require('react_ujs');

// eslint-disable-next-line react-hooks/rules-of-hooks
ReactRailsUJS.useContext(componentRequireContext);

const userAccessToken = document.getElementById('user_access_token');

if (userAccessToken) {
  userAccessToken.addEventListener('input', (event) => {
    const field = event.target;
    const error = document.getElementById('invalid-code');

    if (field.value.length > 0) {
      if (error) {
        error.classList.add('d-none');
      }

      document.querySelector('.user_access_token').classList.remove('has-danger');
    }

    if (field.value.length === 6) {
      field.blur();
      field.readonly = true;

      document.getElementById('checking-code').classList.remove('d-none');
      document.querySelector('form').submit();
    }
  });
}
